module.exports = __webpack_public_path__ + "media/images/logo_daee_aparado-5a9225987dc371260ec76ff90c1ee149.png";